import React from 'react';
import { Form, reduxForm } from 'redux-form';
import { HashLoader } from 'react-spinners';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { AppFileField } from '../../../form/appFileField';
import { required } from '../../../form/formValidations';
import { allowedTemplateExtensions, validateTemplateFile } from '../../utils/fileValidators';
import Button from '../../../buttons/button';
import styles from '../../ClipGeneratorPage.module.scss';

import {
  TemplateUpdateFormOwnProps,
  TemplateUpdateFormDataProps,
  TemplateUpdateFormOnSubmitProps,
} from './templateForm.types';

const TemplateUpdateForm = ({
  form,
  handleSubmit,
  isOpen,
  isLoading,
  onUpdate,
  onClose,
  template,
}: TemplateUpdateFormOwnProps) => {
  const handleOnSubmit = (values: TemplateUpdateFormDataProps) => onUpdate(template, values);

  return (
    <Modal isOpen={isOpen} className={styles.modal}>
      <ModalHeader>Update Template: {template.name}</ModalHeader>
      <ModalBody>
        <Form id={form} onSubmit={handleSubmit(handleOnSubmit)}>
          {!isLoading ? (
            <AppFileField
              name="newZipFile"
              label="Template File (.zip)"
              extensions={allowedTemplateExtensions}
              validate={[required, validateTemplateFile]}
            />
          ) : (
            <div className={styles.loader}>
              <HashLoader />
            </div>
          )}
        </Form>
      </ModalBody>
      {!isLoading && (
        <ModalFooter>
          <Button onClick={onClose} className={styles.cancel} text="Cancel" allCapitals />
          <Button type="submit" form={form} className={styles.submit} text="Submit" allCapitals />
        </ModalFooter>
      )}
    </Modal>
  );
};

export const TemplateUpdateFormContainer = reduxForm<TemplateUpdateFormDataProps, TemplateUpdateFormOnSubmitProps>({
  form: 'templateUpdateForm',
  enableReinitialize: true,
})(TemplateUpdateForm);
